import { Record } from 'immutable';
const TagRecord = Record({
  id: undefined,
  name: undefined
});
export default TagRecord;